
import {Component, Prop, Vue} from "vue-property-decorator";
import ServiceContainer from "@flashpointbv/solar-service-container";

@Component({
  name: 'catalog-product-selected-sku',
  components: ServiceContainer().getComponents()
})
export default class extends Vue {
  @Prop({required: true}) private readonly sku: string;
  @Prop({required: true}) private readonly productType: string;

  private get selectedProduct(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/selectedProducts'];
  }

  private get isConfigurable(): boolean {
    return this.productType === 'configurable';
  }

  private get productSku(): string {
    if (this.isConfigurable) {
      const selectedProducts = this.selectedProduct;
      if (selectedProducts && selectedProducts.length === 1) {
        const product = selectedProducts[0];

        return product['sku'];
      }
    }

    return this.sku;
  }

}
